<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasDispositivosPerm.value" :to="{name: 'catracas-dispositivos'}">Dispositivos</v-btn>
            <v-btn v-if="hasCadastroVisitantesPerm.value" :to="{name: 'catracas-visitantes'}">Visitantes</v-btn>
            <v-btn v-if="hasSolicitCadastroVisitPerm.value" :to="{name: 'catracas-solicitacao'}">Solicitação de Cadastros</v-btn>
            <v-btn v-if="hasParamStatusAlunosPerm.value" :to="{name: 'catracas-parametros-alunos'}">Parâmetros Alunos</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
import { ref, computed } from 'vue';
import  { useRouter } from 'vue-router';
const hasCadastroVisitantesPerm = ref(false)
const hasDispositivosPerm = ref(false)
const hasSolicitCadastroVisitPerm = ref(false)
const hasParamStatusAlunosPerm = ref(false)
const router = useRouter();
hasDispositivosPerm.value = computed(() => router.resolve({name: 'catracas-dispositivos'}).meta.has_perm() )
hasCadastroVisitantesPerm.value = computed(() => router.resolve({name: 'catracas-visitantes'}).meta.has_perm())
hasSolicitCadastroVisitPerm.value = computed(() => router.resolve({name: 'catracas-solicitacao'}).meta.has_perm())
hasParamStatusAlunosPerm.value = computed(() => router.resolve({name: 'catracas-parametros-alunos'}).meta.has_perm())
</script>